// @flow
import { css } from 'glamor'
import { fonts } from './styleConfig'
import * as colors from './constants/color'

css.global('body', {
  fontFamily: fonts.fontFamily,
  textRendering: 'optimizeLegibility',
  color: colors.black,
})



// WEBPACK FOOTER //
// ./src/style/base.js